import { getEnvValue } from '@env/getEnvValue'

const thirdPartyAppsEnv = {
  NEXT_PUBLIC_SEGMENT_CDN_URL: getEnvValue(process.env.NEXT_PUBLIC_SEGMENT_CDN_URL),
  NEXT_PUBLIC_SEGMENT_OPEN_SNOWCAT_URL: getEnvValue(process.env.NEXT_PUBLIC_SEGMENT_OPEN_SNOWCAT_URL),
  NEXT_PUBLIC_CLARITY_ID: getEnvValue(process.env.NEXT_PUBLIC_CLARITY_ID)
}

export { thirdPartyAppsEnv }
